import React from 'react';
import { PublicLayout } from '../components/PublicLayout';
import { Link } from 'react-router-dom';
import { MapPin, Users, Building2, ArrowRight } from 'lucide-react';

const wilayahData = [
  { no: 1, name: 'Kuching', pengerusi: 'Abdul Taib Bin Yusup', region: 'Selatan Sarawak', color: '#D71920' },
  { no: 2, name: 'Kota Samarahan', pengerusi: 'Haji Issnu Bin Dollah', region: 'Selatan Sarawak', color: '#D71920' },
  { no: 3, name: 'Serian', pengerusi: 'Mohamed Tuah Bin Wasli', region: 'Selatan Sarawak', color: '#D71920' },
  { no: 4, name: 'Sri Aman', pengerusi: 'Abdul Wahab Bin Abdul Wahid', region: 'Tengah Sarawak', color: '#D4AF37' },
  { no: 5, name: 'Betong', pengerusi: 'Mohd Kahlik Bin Jerni', region: 'Tengah Sarawak', color: '#D4AF37' },
  { no: 6, name: 'Sarikei', pengerusi: 'Dayangku Siti Mariam Bt Awg Masli', region: 'Tengah Sarawak', color: '#D4AF37' },
  { no: 7, name: 'Sibu', pengerusi: 'Mohamad Razalee bin Hassan', region: 'Tengah Sarawak', color: '#D4AF37' },
  { no: 8, name: 'Mukah', pengerusi: 'Jamal Bin Wasli', region: 'Tengah Sarawak', color: '#D4AF37' },
  { no: 9, name: 'Kapit', pengerusi: 'Awg. Rosman bin Awg. Japar', region: 'Pedalaman Sarawak', color: '#0B0B0B' },
  { no: 10, name: 'Bintulu', pengerusi: 'Rushdy bin Rosli', region: 'Utara Sarawak', color: '#555' },
  { no: 11, name: 'Miri', pengerusi: 'Haji Madon Bin Sulong', region: 'Utara Sarawak', color: '#555' },
  { no: 12, name: 'Limbang', pengerusi: 'Haji Razduan Bin Ibrahim', region: 'Utara Sarawak', color: '#555' },
  { no: 13, name: 'Lawas', pengerusi: 'Mohamad Noor bin Ahmat', region: 'Utara Sarawak', color: '#555' },
];

const regions = [
  { label: 'Selatan Sarawak', color: '#D71920', wilayah: ['Kuching', 'Kota Samarahan', 'Serian'] },
  { label: 'Tengah Sarawak', color: '#D4AF37', wilayah: ['Sri Aman', 'Betong', 'Sarikei', 'Sibu', 'Mukah'] },
  { label: 'Pedalaman Sarawak', color: '#0B0B0B', wilayah: ['Kapit'] },
  { label: 'Utara Sarawak', color: '#555', wilayah: ['Bintulu', 'Miri', 'Limbang', 'Lawas'] },
];

export default function Wilayah() {
  return (
    <PublicLayout>
      {/* Page Header */}
      <div className="bg-[#0B0B0B] text-white py-16">
        <div className="h-0.5 bg-gradient-to-r from-[#D71920] via-[#FFD21F] to-[#D71920] -mt-16 mb-16" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <p className="text-xs text-[#FFD21F] font-bold tracking-widest uppercase mb-3">Utama / Wilayah</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight" data-testid="wilayah-title">
            13 Wilayah RSS Sarawak
          </h1>
          <p className="text-[#999] mt-3 text-sm sm:text-base max-w-2xl">
            Rumpun Silat Sarawak beroperasi merentasi 13 wilayah di seluruh negeri Sarawak, dipimpin oleh pengerusi wilayah yang dilantik.
          </p>
        </div>
      </div>

      {/* Stats */}
      <div className="bg-[#D71920] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5">
          <div className="grid grid-cols-3 sm:divide-x sm:divide-white/20">
            {[
              { value: '13', label: 'Wilayah RSS' },
              { value: '168', label: 'Perguruan Gabungan' },
              { value: '15,000+', label: 'Ahli Berdaftar' },
            ].map((s, i) => (
              <div key={i} className="text-center sm:px-4">
                <div className="text-2xl font-extrabold text-[#FFD21F]">{s.value}</div>
                <div className="text-xs font-semibold text-white/90 mt-0.5">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Region Summary */}
      <section className="bg-white py-10 border-b border-[#E5E5E5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-xs font-bold tracking-widest text-[#D71920] uppercase mb-5">Pembahagian Kawasan</div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {regions.map((r, i) => (
              <div key={i} className="border border-[#E5E5E5] rounded p-4" style={{ borderLeftColor: r.color, borderLeftWidth: 3 }}>
                <div className="font-bold text-[#0B0B0B] text-sm mb-2">{r.label}</div>
                <div className="flex flex-wrap gap-1">
                  {r.wilayah.map(w => (
                    <span key={w} className="text-[10px] bg-[#F7F7F7] border border-[#E5E5E5] text-[#555] px-2 py-0.5 rounded">
                      {w}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Wilayah Grid */}
      <section className="bg-[#F7F7F7] py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-xs font-bold tracking-widest text-[#D71920] uppercase mb-3">Senarai Wilayah</div>
          <h2 className="text-2xl font-extrabold text-[#0B0B0B] mb-8">Pengerusi RSS Wilayah</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {wilayahData.map((w, i) => (
              <div
                key={i}
                className="bg-white border border-[#E5E5E5] rounded overflow-hidden hover:shadow-md transition-all group"
                data-testid={`wilayah-card-${i}`}
              >
                <div className="h-1" style={{ backgroundColor: w.color }} />
                <div className="p-5">
                  <div className="flex items-start justify-between mb-3">
                    <div>
                      <span className="text-[10px] font-bold text-[#999] tracking-widest uppercase">Wilayah {w.no}</span>
                      <h3 className="font-extrabold text-[#0B0B0B] text-base mt-0.5">RSS Wilayah {w.name}</h3>
                    </div>
                    <div className="w-8 h-8 rounded-full flex items-center justify-center text-xs font-extrabold flex-shrink-0"
                      style={{ backgroundColor: w.color + '15', color: w.color === '#0B0B0B' || w.color === '#555' ? '#D71920' : w.color }}>
                      {w.no}
                    </div>
                  </div>

                  <div className="space-y-2">
                    <div className="flex items-center gap-2">
                      <MapPin size={11} className="text-[#D71920] flex-shrink-0" />
                      <span className="text-xs text-[#777]">{w.region}</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <Users size={11} className="text-[#D71920] flex-shrink-0 mt-0.5" />
                      <div>
                        <span className="text-[10px] text-[#999] uppercase font-bold tracking-wide block">Pengerusi</span>
                        <span className="text-xs font-semibold text-[#0B0B0B]">{w.pengerusi}</span>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 pt-3 border-t border-[#F7F7F7]">
                    <div className="flex justify-between items-center text-xs text-[#bbb]">
                      <span className="flex items-center gap-1">
                        <Building2 size={10} />
                        Perguruan berdaftar
                      </span>
                      <span className="font-semibold text-[#999]">—</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Note */}
      <section className="bg-white py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="p-5 bg-[#FFFBF0] border border-[#D4AF37]/30 rounded">
            <p className="text-sm text-[#7a6200] leading-relaxed">
              <strong>Nota:</strong> Maklumat terperinci bagi setiap wilayah termasuk senarai perguruan, bilangan ahli dan aktiviti
              akan dikemaskini oleh Sekretariat RSS Sarawak. Untuk pertanyaan tentang wilayah tertentu, sila{' '}
              <Link to="/hubungi" className="font-semibold text-[#D71920] hover:underline">hubungi sekretariat</Link>.
            </p>
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/direktori-perguruan"
              className="inline-flex items-center gap-2 bg-[#D71920] hover:bg-[#b8161c] text-white text-sm font-semibold px-5 py-3 rounded transition-colors"
              data-testid="cta-direktori-btn"
            >
              Lihat Direktori Perguruan <ArrowRight size={14} />
            </Link>
            <Link
              to="/kepimpinan"
              className="inline-flex items-center gap-2 border border-[#0B0B0B] text-[#0B0B0B] hover:bg-[#0B0B0B] hover:text-white text-sm font-semibold px-5 py-3 rounded transition-colors"
              data-testid="cta-kepimpinan-btn"
            >
              Lihat Pengerusi Wilayah
            </Link>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
